import { render, staticRenderFns } from "./DrawerHubCommissionSettings.vue?vue&type=template&id=448ec83c"
import script from "./DrawerHubCommissionSettings.vue?vue&type=script&lang=js"
export * from "./DrawerHubCommissionSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports